export const SectionTitle = ({ title, rightBtn }) => {
  return (
    <div className="header-title my-4">
      <div className="d-flex justify-content-between align-items-center w-100">
        <div>{title}</div>
        <div>{rightBtn}</div>
      </div>
    </div>
  );
};
